export const NOTIFICATION_CHANNEL_QUERY_PARAM = 'notification_channel';

export type NotificationLinkChannel = 'email' | 'slack';

export type NotificationLinkAnalytics = {
  notificationId: number;
  channel: NotificationLinkChannel;
  notificationType: string | null;
};

const isNotificationLinkChannel = (value: string | null): value is NotificationLinkChannel =>
  value === 'email' || value === 'slack';

const getNotificationLinkChannel = (
  searchParams: URLSearchParams
): NotificationLinkChannel | null => {
  const rawChannel = searchParams.get(NOTIFICATION_CHANNEL_QUERY_PARAM);
  if (isNotificationLinkChannel(rawChannel)) {
    return rawChannel;
  }

  return rawChannel == null ? 'email' : null;
};

export const getNotificationLinkAnalytics = (
  searchParams: URLSearchParams
): NotificationLinkAnalytics | null => {
  const rawNotificationId = searchParams.get('n');
  if (!rawNotificationId) {
    return null;
  }

  const notificationId = Number(rawNotificationId);
  if (!Number.isInteger(notificationId)) {
    return null;
  }

  const channel = getNotificationLinkChannel(searchParams);
  if (!channel) {
    return null;
  }

  return {
    notificationId,
    channel,
    notificationType: searchParams.get('notification_type'),
  };
};
